import { getDefaultShopConfig } from './default';
import * as custom from '../filters/marketplace-custom-config';
import { getBrandDirectFilterConfig } from '../filters/brandDirect';
import { getConditionsFilterConfig } from '../filters/condition';
import { getSizeFilterConfig } from '../filters/size';
import { BuilderSections } from '../../util/builder';

const tripleaughtdesignSizes = [
  'XXS',
  'XS',
  'S',
  'M',
  'L',
  'XL',
  '2L',
  '3L',
  '28x30',
  '30x30',
  '30x32',
  '30x34',
  '32x30',
  '32x32',
  '32x34',
  '34x30',
  '34x32',
  '34x34',
  '36x30',
  '36x32',
  '36x34',
  '38x30',
  '38x32',
  '38x34',
  '40x30',
  '40x32',
  '7 Mens',
  '7.5 Mens',
  '8 Mens',
  '8.5 Mens',
  '9 Mens',
  '9.5 Mens',
  '10 Mens',
  '10.5 Mens',
  '11 Mens',
  '11.5 Mens',
  '12 Mens',
  '13 Mens',
  'One Size',
];

export const tripleaughtdesignShopConfig = {
  ...getDefaultShopConfig(),
  filters: [
    ...custom.filters,
    getConditionsFilterConfig(),
    getBrandDirectFilterConfig(),
    getSizeFilterConfig({ sizes: tripleaughtdesignSizes }),
  ],
};
